import Vue from "vue";
import { BootstrapVue } from 'bootstrap-vue';
import '@popperjs/core'; // Edit here
import 'bootstrap/dist/js/bootstrap.bundle'
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import Vuex from 'vuex'
import { store } from '../store';
import Vuelidate from 'vuelidate'
import VueExcelEditor from 'vue-excel-editor'


Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(Vuelidate)
Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(VueExcelEditor)

new Vue({
  router,
  store:store,
  render: h => h(App)
}).$mount("#app");
